module.exports = __webpack_public_path__ + "img/2560px-Google_Meet_text_logo_(2020).svg_2x.1b2ef0e1.png";